<div class="flex flex-wrap justify-center">
  <div class="payemnt-container">
    <app-boleto-payment *ngIf="(isStripeProvider() || isCieloProvider()) && isBoleto() && cobranca"
      [cobranca]="cobranca"></app-boleto-payment>

    <app-stripe-payment *ngIf="isStripeProvider() && isCartao() && cobranca && cobranca.stripeClientSecret !== null"
      [locale]="locale" [cobranca]="cobranca"></app-stripe-payment>

    <app-payment-cielo *ngIf="isCieloProvider() && isCartao()" [invoice]="invoice"
      [formaPagamento]="formaPagamento"></app-payment-cielo>

    <app-pix-payment *ngIf="!isStripeProvider() && isPix() && cobranca" [locale]="locale"
      [cobranca]="cobranca"></app-pix-payment>
  </div>
</div>
